import { requestGet } from '@/utils/request';
import { TApi } from '@/types/interface';
import { TCardCamp } from '@/types/camp/CardCamp';

// 获取打卡营列表
export function getCampProductist() {
  return requestGet('/v2/camp/api/card/camp/list', {});
}

export const getCardCampInfo = async (id: string): Promise<TApi<TCardCamp>> => {
  return requestGet(`/v2/camp/api/card/camp/${id}`, {});
};
